import "./personality.css";
import React, { useEffect, useState } from "react";

// 🖼️ Posters
import adifferentman from "../../movies/belleza/adifferentman.jpg";
import americanbeauty from "../../movies/belleza/americanbeauty.jpg";
import breakfastattiffanys from "../../movies/belleza/breakfastattiffanys.jpg";
import gia from "../../movies/belleza/gia.jpg";
import helterskelter from "../../movies/belleza/helterskelter.jpg";
import marieantoinette from "../../movies/belleza/marieantoinette.jpg";
import moulinrouge from "../../movies/belleza/moulinrouge.jpg";
import secretary from "../../movies/belleza/secretary.jpg";
import thesubstance from "../../movies/belleza/thesubstance.jpg";
import valleyofthedolls from "../../movies/belleza/valleyofthedolls.jpg";

// 🎬 Datos reales
const movies = [
  {
    title: "A Different Man",
    image: adifferentman,
    director: "Aaron Schimberg",
    year: 2017,
    cast: "Colin Farrell, Rebecca Hall",
    synopsis:
      "Una historia de transformación personal y aceptación en la vida de un hombre que enfrenta una pérdida y busca reinventarse.",
  },
  {
    title: "American Beauty",
    image: americanbeauty,
    director: "Sam Mendes",
    year: 1999,
    cast: "Kevin Spacey, Annette Bening, Thora Birch",
    synopsis:
      "Un hombre en crisis de mediana edad experimenta cambios en su vida y percepción de la belleza que lo rodea.",
  },
  {
    title: "Breakfast at Tiffany's",
    image: breakfastattiffanys,
    director: "Blake Edwards",
    year: 1961,
    cast: "Audrey Hepburn, George Peppard",
    synopsis:
      "Una joven sofisticada y misteriosa vive en Nueva York buscando su lugar en el mundo mientras encuentra el amor inesperadamente.",
  },
  {
    title: "Gia",
    image: gia,
    director: "Michael Cristofer",
    year: 1998,
    cast: "Angelina Jolie, Faye Dunaway",
    synopsis:
      "La vida de Gia Carangi, una supermodelo icónica de los años 70, marcada por la fama, el amor y la tragedia.",
  },
  {
    title: "Helter Skelter",
    image: helterskelter,
    director: "Tommy Lee Wallace",
    year: 1976,
    cast: "Steve Railsback, Shirley Knight",
    synopsis:
      "La historia real del ascenso y caída de la familia Manson y los crímenes que conmocionaron a Estados Unidos.",
  },
  {
    title: "Marie Antoinette",
    image: marieantoinette,
    director: "Sofia Coppola",
    year: 2006,
    cast: "Kirsten Dunst, Jason Schwartzman",
    synopsis:
      "Una visión estilizada de la vida de la famosa reina francesa, desde su llegada a Versalles hasta la revolución.",
  },
  {
    title: "Moulin Rouge!",
    image: moulinrouge,
    director: "Baz Luhrmann",
    year: 2001,
    cast: "Nicole Kidman, Ewan McGregor",
    synopsis:
      "Una historia de amor trágica y apasionada ambientada en el cabaret más famoso de París a principios del siglo XX.",
  },
  {
    title: "Secretary",
    image: secretary,
    director: "Steven Shainberg",
    year: 2002,
    cast: "Maggie Gyllenhaal, James Spader",
    synopsis:
      "La relación poco convencional entre una secretaria y su jefe, explorando temas de poder, deseo y autoaceptación.",
  },
  {
    title: "The Substance",
    image: thesubstance,
    director: "Coralie Fargeat",
    year: 2024,
    cast: "Demi Moore, Margaret Qualley, Dennis Quaid",
    synopsis:
      "Tras ser despedida por su edad, una celebridad utiliza una droga que crea una versión más joven de ella misma con consecuencias inesperadas.",
  },
  {
    title: "Valley of the Dolls",
    image: valleyofthedolls,
    director: "Mark Robson",
    year: 1967,
    cast: "Barbara Parkins, Patty Duke, Sharon Tate",
    synopsis:
      "Tres mujeres enfrentan fama, amor y dependencia en la industria del espectáculo, explorando belleza y fragilidad.",
  },
];

// ⭐⭐⭐⭐⭐ Letterboxd-style SVGs
const EmptyStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const FullStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <path
      fill="currentColor"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

const HalfStar = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" className="star-svg">
    <defs>
      <linearGradient id="halfGradient">
        <stop offset="50%" stopColor="currentColor" />
        <stop offset="50%" stopColor="transparent" />
      </linearGradient>
    </defs>
    <path
      fill="url(#halfGradient)"
      stroke="currentColor"
      strokeWidth="2"
      d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.56 5.82 22 7 14.14l-5-4.87 6.91-1.01z"
    />
  </svg>
);

// ⭐ Rating component
function StarRating({ value = 0, onChange, active }) {
  const [hover, setHover] = useState(0);

  if (!active) return null;

  const displayed = hover || value;

  return (
    <div className="stars-container">
      {[1, 2, 3, 4, 5].map((n) => {
        let StarComponent = EmptyStar;
        if (displayed >= n) StarComponent = FullStar;
        else if (displayed >= n - 0.5) StarComponent = HalfStar;

        return (
          <div
            key={n}
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              const x = e.clientX - rect.left;
              setHover(x < rect.width / 2 ? n - 0.5 : n);
            }}
            onMouseLeave={() => setHover(0)}
            onClick={() => onChange(hover || value)}
            className="star-wrapper"
          >
            <StarComponent />
          </div>
        );
      })}
    </div>
  );
}

function Belleza() {
  useEffect(() => window.scrollTo(0, 0), []);

  const [seen, setSeen] = useState(() =>
    JSON.parse(localStorage.getItem("seenMoviesBelleza") || "{}")
  );
  const [ratings, setRatings] = useState(() =>
    JSON.parse(localStorage.getItem("ratingsBelleza") || "{}")
  );

  const toggleSeen = (title) => {
    const newSeen = { ...seen, [title]: !seen[title] };
    setSeen(newSeen);
    localStorage.setItem("seenMoviesBelleza", JSON.stringify(newSeen));

    if (!newSeen[title]) {
      const r = { ...ratings };
      delete r[title];
      setRatings(r);
      localStorage.setItem("ratingsBelleza", JSON.stringify(r));
    }
  };

  const updateRating = (title, rating) => {
    const r = { ...ratings, [title]: rating };
    setRatings(r);
    localStorage.setItem("ratingsBelleza", JSON.stringify(r));
  };

  return (
    <div className="personality-container">
      <h1>Belleza</h1>
      <p>
        Es un espíritu independiente y hermoso, que podria describir de vos en este aspecto...
      </p>

      <div className="movies-grid">
        {movies.map((movie) => {
          const isSeen = seen[movie.title];
          const rating = ratings[movie.title] || 0;

          return (
            <div key={movie.title} className="movie-card">
              <div className="movie-card-inner">
                <div className="movie-card-front">
                  <img
                    src={movie.image}
                    alt={movie.title}
                    className={`movie-poster ${isSeen ? "dimmed" : ""}`}
                  />
                </div>
                <div className="movie-card-back">
                  <h3>{movie.title}</h3>
                  <p><strong>Director:</strong> {movie.director}</p>
                  <p><strong>Año:</strong> {movie.year}</p>
                  <p><strong>Reparto:</strong> {movie.cast}</p>
                  <p><strong>Sinopsis:</strong> {movie.synopsis}</p>

                  <button
                    className={`fancy-button ${isSeen ? "active" : ""}`}
                    onClick={() => toggleSeen(movie.title)}
                  >
                    {isSeen ? "✔ La viste" : "Marcar como vista"}
                  </button>

                  <StarRating
                    value={rating}
                    onChange={(v) => updateRating(movie.title, v)}
                    active={isSeen}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Belleza;

